/* src/app/warehousing/pages/product-groups-new/product-groups-new.component.scss */
/*# sourceMappingURL=product-groups-new.component.css.map */
